import React, { useState } from "react";
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from "react-icons/md";

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqData = [
    {
      question: "What is KCT?",
      answer: "The key change token (KCT) is a group of 2 sets of numbers (usually 20 each) that are loaded into a prepaid meter when it is not accepting electricity tokens in cases when there is a change in tariff or platform.",
    },
    {
      question: "What is CIU?",
      answer: "CIU (Customer Interface Unit) is a keypad that will display the meters parameters automatically or through Push mode. It is located at consumer premises and is wired from a meter.",
    },
    {
      question: "What is tariff?",
      answer: "The amount of money framed by the supplier for the supply of electrical energy to various types of consumers in known as an electricity tariff.",
    },
    {
      question: "Why am I unable to load my meter, its showing reject?",
      answer: "The meter requires new KCT to enable you load the token.",
    },
    {
      question: "Why does my meter show EEE when I try to load?",
      answer: "The token is on a different tariff and it requires KCT.",
    },
    {
      question: "Why is my meter showing a spanner sign?",
      answer: "This means that your prepaid meter requires a clear tamper code to reset it to default mode.",
    },
    {
      question: "How long does it take to generate KCT/clear tamper?",
      answer: "It takes 24hrs.",
    },
    {
      question: "Would I always need KCT before I can vend?",
      answer: "Not always, however, if there is a change in meter tariff. It will require a new KCT.",
    },
    {
      question: "What causes my meter to go into tamper mode?",
      answer: "The meter terminal is not positioned well, an attempt in meter bypass can still result if the meter is smart and has a fluctuating power supply.",
    },
    {
      question: "Why does the KCT generated not work?",
      answer: "The right tariff was not used in applying for it.",
    },
    {
      question: "How to load KCT/clear tamper?",
      answer: "KCT is 40 digit code. Divide it into two load /keys in the first 20 and the second 20 digits then load your token.",
    },
    {
      question: "I bought a token and it didn't enter my meter, why?",
      answer: "The meter requires new KCT or there is no supply on your current supply phase.",
    },
    {
      question: "After loading my token, it just blinked and didn't show anything why?",
      answer: "It could be that you mistyped the wrong token digit or the keypad is not paired to the meter.",
    },
    {
      question: "I successfully loaded my token, but no light in my apartment, what could be the cause?",
      answer: "Your prepaid meter has entered tamper mode and requires clear tamper to activate back.",
    },
  ];

  const shortCodes = [
    { type: "ATARIS (E.G 0132.....)", tariff: "05", sgc: "" },
    { type: "COLOG (E.G 041...., 042....", tariff: "#006#", sgc: "#030#" },
    { type: "MOJEC (E.G 541......, 01011...., 01012......)", tariff: "82,34,32,36,802", sgc: "030" },
    { type: "WELLSUN (E.G 0137….)", tariff: "117", sgc: "116" },
    { type: "HOLLEY (E.G 25700…)", tariff: "06", sgc: "030" },
    { type: "CWG", tariff: "809", sgc: "805" },
    { type: "HEXING (E.G 142….)", tariff: "06", sgc: "030" },
    { type: "QUANTUM/GENUS (E.G 2710…..)", tariff: "#006#" },
  ];

  return (
    <div className="w-full min-h-screen bg-white">
      {/* Header Section */}
      <div className="relative bg-[#14532d] text-white py-8 md:py-12 overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.4'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
            backgroundSize: '60px 60px'
          }}> 
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 relative z-10">
          <div className="flex flex-col lg:flex-row items-center justify-between">
            <div className="lg:w-2/3">
              <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-extrabold leading-tight uppercase tracking-tight">
                Frequently Asked <span className="text-yellow-400">Questions</span>
              </h2>
              <div className="w-20 h-1.5 bg-yellow-400 rounded-full mt-2 mb-0"></div>
            </div>
          </div>
        </div>
      </div>

      {/* FAQ Accordion Section */}
      <section className="max-w-5xl mx-auto px-6 py-10">
        <div className="space-y-4">
          {faqData.map((faq, index) => (
            <div
              key={index}
              className={`rounded-3xl border transition-all duration-300 ${
                openIndex === index ? "bg-gray-50 border-green-700 shadow-xl" : "bg-white border-gray-100 hover:border-green-300"
              }`}
            >
              <button
                onClick={() => toggleAccordion(index)}
                className="w-full flex items-center justify-between p-5 md:p-6 text-left group"
              >
                <div className="flex items-center gap-4">
                  <div className={`w-3 h-3 rounded-full transition-colors ${openIndex === index ? "bg-yellow-400" : "bg-green-700"}`}></div>
                  <span className={`text-base md:text-lg font-black uppercase tracking-tight transition-colors ${openIndex === index ? "text-green-700" : "text-black group-hover:text-green-700"}`}>
                    {faq.question}
                  </span>
                </div>
                {openIndex === index ? (
                  <div className="bg-green-700 text-white p-1 rounded-full"><MdKeyboardArrowUp className="text-xl" /></div>
                ) : (
                  <div className="bg-gray-100 text-gray-400 p-1 rounded-full"><MdKeyboardArrowDown className="text-xl" /></div>
                )}
              </button>

              <div
                className={`overflow-hidden transition-all duration-500 ${
                  openIndex === index ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
                }`}
              >
                <div className="px-10 md:px-14 pb-6">
                  <div className="w-full h-px bg-gray-200 mb-4"></div>
                  <p className="text-base text-gray-600 font-medium leading-relaxed italic border-l-4 border-yellow-400 pl-6">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* SHORT CODES TABLE */}
      <section className="max-w-5xl mx-auto px-6 pb-12">
        <div className="bg-black rounded-3xl p-1 shadow-2xl overflow-hidden">
          <div className="bg-white rounded-[1.4rem] overflow-hidden">
            <div className="p-6 border-b border-gray-100 flex justify-between items-center bg-gray-50/50">
              <h3 className="text-xl font-black text-black uppercase tracking-tighter">Meter Short Codes</h3>
              <span className="bg-green-700 text-white px-4 py-1 rounded-full text-[10px] font-black uppercase tracking-widest">Reference Guide</span>
            </div>
            <div className="overflow-x-auto">
              <table className="w-full text-left border-collapse">
                <thead>
                  <tr className="bg-black text-white uppercase text-[10px] font-black tracking-[0.2em]">
                    <th className="px-6 py-4">Meter Type</th>
                    <th className="px-6 py-4">Tariff Code</th>
                    <th className="px-6 py-4">SGC Code</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-100">
                  {shortCodes.map((code, idx) => (
                    <tr key={idx} className="group hover:bg-green-50 transition-colors">
                      <td className="px-6 py-4 font-black text-black uppercase text-sm">{code.type}</td>
                      <td className="px-6 py-4">
                        <span className="bg-gray-100 px-3 py-1 rounded-lg text-green-700 font-mono font-black text-sm group-hover:bg-white transition-colors border border-transparent group-hover:border-green-200">
                          {code.tariff}
                        </span>
                      </td>
                      <td className="px-6 py-4">
                        {code.sgc && (
                          <span className="bg-white px-3 py-1 rounded-lg text-yellow-600 font-mono font-black text-sm border border-yellow-100">
                            {code.sgc}
                          </span>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FAQ;